import React, { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import SelectionUploadButton from "../../../../atoms/selection/SelectionUploadButton";
import { ReactComponent as IconSelect } from "./select-photos.svg";
import { ReactComponent as IconArrow } from "../../../../../icons/chevron-right.svg";
import { ReactComponent as IconOptions } from "../../../../../icons/options.svg";
import { ReactComponent as IconMagic } from "../../../../../icons/magic.svg";
import "./style.scss";

interface Props {
  onFileChange: (files: File[]) => Promise<void>;
}
const UploadOnboarding: FunctionComponent<Props> = ({ onFileChange }) => {
  const intl = useIntl();

  return (
    <div className="UploadOnboarding">
      <div className="UploadOnboarding-upload">
        <SelectionUploadButton onFileChange={onFileChange}>
          {intl.formatMessage({ id: "kustom_UploadOnboarding_import" })}
        </SelectionUploadButton>
      </div>

      <div className="UploadOnboarding-steps">
        <div className="UploadOnboarding-steps-item">
          <div className="UploadOnboarding-steps-item-icon">
            <IconSelect />
          </div>
          <div className="UploadOnboarding-steps-item-title">
            {intl.formatMessage({ id: "kustom_UploadOnboarding_select_title" })}
          </div>
          <div className="UploadOnboarding-steps-item-description">
            {intl.formatMessage({ id: "kustom_UploadOnboarding_select_description" })}
          </div>
        </div>

        <IconArrow />

        <div className="UploadOnboarding-steps-item">
          <div className="UploadOnboarding-steps-item-icon">
            <IconMagic />
          </div>
          <div className="UploadOnboarding-steps-item-title">
            {intl.formatMessage({ id: "kustom_UploadOnboarding_fill_title" })}
          </div>
          <div className="UploadOnboarding-steps-item-description">
            {intl.formatMessage({ id: "kustom_UploadOnboarding_fill_description" })}
          </div>
        </div>

        <IconArrow />

        <div className="UploadOnboarding-steps-item">
          <div className="UploadOnboarding-steps-item-icon">
            <IconOptions />
          </div>
          <div className="UploadOnboarding-steps-item-title">
            {intl.formatMessage({ id: "kustom_UploadOnboarding_customize_title" })}
          </div>
          <div className="UploadOnboarding-steps-item-description">
            {intl.formatMessage({ id: "kustom_UploadOnboarding_customize_description" })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadOnboarding;
